var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Label from '../../../../components/Label';
import t from '../../../../lib/translate';
import EditTemplates from '../../scenes/EditTemplate/hooks';
import SendWindowLine from './components/SendWindowLine';
import { StyledAddButton, StyledTable } from './styles/styles';
var SendWindowEditor = function () {
    var _a = EditTemplates.useContainer(), sendWindows = _a.sendWindows, setSendWindows = _a.setSendWindows;
    var onChange = function (id, field, value) {
        var windows = __spreadArray([], sendWindows, true);
        windows[id][field] = value;
        setSendWindows(windows);
    };
    var onRemove = function (id) {
        var windows = sendWindows.filter(function (e, index) { return index !== id; });
        setSendWindows(windows);
    };
    var add = function () {
        var windows = __spreadArray([], sendWindows, true);
        windows.push({
            start: '',
            end: '',
            days: ''
        });
        setSendWindows(windows);
    };
    return (_jsxs("div", { children: [_jsx(Label, { label: t('windows.edit.header') }), _jsxs(StyledTable, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: t('windows.edit.headers.send.windows') }), sendWindows.length > 0 &&
                                    _jsxs(_Fragment, { children: [_jsx("th", { children: t('windows.edit.headers.mon') }), _jsx("th", { children: t('windows.edit.headers.tue') }), _jsx("th", { children: t('windows.edit.headers.wed') }), _jsx("th", { children: t('windows.edit.headers.thu') }), _jsx("th", { children: t('windows.edit.headers.fri') }), _jsx("th", { children: t('windows.edit.headers.sat') }), _jsx("th", { children: t('windows.edit.headers.sun') }), _jsx("th", {})] })] }) }), _jsx("tbody", { children: sendWindows.map(function (window, id) {
                            // eslint-disable-next-line
                            return SendWindowLine({ id: id, window: window, onChange: onChange, onRemove: onRemove });
                        }) })] }), _jsx(StyledAddButton, __assign({ onClick: add }, { children: t('windows.edit.add') }))] }));
};
export default SendWindowEditor;
